
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import SanityDocument from '~/components/Sanity/SanityDocument.vue';
import SanityReference from '~/components/Sanity/SanityReference.vue';
import SignUpForAlertsBtn from '~/components/UIComponents/SignUpForAlertsBtn.vue';
import PageHeroContainer from '~/components/UIComponents/PageHeroContainer.vue';
import WatchVideoDialog from '~/components/Sanity/WatchVideoDialog.vue';

@Component({
  components: {
    SanityDocument,
    SanityReference,
    SignUpForAlertsBtn,
    PageHeroContainer,
    WatchVideoDialog,
  },
})
export default class FilmHero extends Vue {
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.FILM];

  schemas = SanityDocumentSchema;
  videoSchema = SanityDocumentSchema.VIDEO;

  get backgroundImage() {
    if (!this.doc?.pageHeroImage) {
      return;
    }

    return this.$sanityImage.urlFor(this.doc.pageHeroImage).url();
  }

  get overline() {
    return this.doc?.overline || '';
  }

  get title() {
    return this.doc?.title || '';
  }

  get titleBadges() {
    return this.doc?.titleBadges || [];
  }

  get trailerId() {
    return this.doc?.trailer?._ref || '';
  }

  get hasActiveCampaignTag() {
    return this.doc?.activeCampaignId;
  }

  get activeCampaignTag() {
    return this.doc?.activeCampaignId ? this.doc?.activeCampaignId : '66';
  }

  get showAlertSignupButton() {
    return !this.doc?.contentAvailability?.isWatchable;
  }
}
